import React from 'react';

/**
 * TargetMarketSection Component
 * 
 * Displays "Who Is It For?" section with target market cards.
 * 
 * Exact styles from landing.css:
 * - Grid: repeat(auto-fit, minmax(280px, 1fr))
 * - Info block padding: 1.5rem (24px)
 * - Border radius: 16px
 * - Background: rgba(255, 255, 255, 0.03) with backdrop blur 15px
 */
const TargetMarketSection = () => {
  const targetMarkets = [
    {
      id: 1,
      title: 'Public',
      description: 'Everyone has a right to access the truth. Simplify complex legal jargon.',
    },
    {
      id: 2,
      title: 'Courts',
      description: 'Ease the jurisdiction process for judges with organized data.',
    },
    {
      id: 3,
      title: 'Companies',
      description: 'Follow rights and duties on time. Stay compliant effortlessly.',
    },
    {
      id: 4,
      title: 'Lawyers & Students',
      description: 'Access real knowledge for investigation and learning.',
    },
  ];

  return (
    <section id="target-market" className="section py-section-mobile md:py-section-tablet lg:py-section-desktop px-4 md:px-6 lg:px-8 max-w-[1200px] mx-auto relative z-10">
      <h2 className="section-title text-center text-mobile-section-title md:text-2xl lg:text-section-title font-medium mb-6 md:mb-10 lg:mb-12 text-text-primary leading-tight md:leading-normal">
        Who is <span className="lawnance-brand">LAWNANCE</span> for?
      </h2>

      {/* Target Market Grid - MOBILE: Mobile-first spacing */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6 lg:gap-8">
        {targetMarkets.map((market) => (
          <div
            key={market.id}
            className="info-block p-4 md:p-6 rounded-info-block border border-white/[0.08] transition-all duration-300 shadow-info-block hover:-translate-y-1 hover:shadow-info-block-hover hover:border-white/15"
            style={{
              background: 'rgba(255, 255, 255, 0.03)',
              backdropFilter: 'blur(15px)',
              WebkitBackdropFilter: 'blur(15px)',
            }}
          >
            <h4 className="text-lg md:text-xl lg:text-info-block-title mb-2 text-text-primary">
              {market.title}
            </h4>
            <p className="text-text-secondary text-sm md:text-base lg:text-card-text">
              {market.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TargetMarketSection;

